export default __webpack_public_path__ + "static/media/flag-maldives.59450f3c.svg";